import { render, staticRenderFns } from "./alt-timeline.vue?vue&type=template&id=515d33c5&scoped=true&"
import script from "./alt-timeline.vue?vue&type=script&lang=ts&"
export * from "./alt-timeline.vue?vue&type=script&lang=ts&"
import style0 from "./alt-timeline.vue?vue&type=style&index=0&id=515d33c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515d33c5",
  null
  
)

export default component.exports